export default {
	data() {
		return {};
	},
};